import React, { Component } from 'react';

export class ItemsList extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        console.log("PUTAWAY ITEMS", this.props.putawayItems);
        return (
            <div className="scrollable-list">
                <table className="table" aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.putawayItems.map(item => {
                            const statusClass = item.qty === 0 ? "putaway" : item.quantityPutaway === 0 ? "not-putaway" : "partially-putaway";
                            return (
                                <tr key={item.itemId} className={statusClass}>
                                    <td>{item.displayname}</td>
                                    <td>{item.qty}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}